const TIME_ZONE = 'Europe/Vienna'

export function momentLabel(iso: string, locale: string, now: Date): string {
  const date = new Date(iso)
  return new Intl.DateTimeFormat(locale, {
    timeZone: TIME_ZONE,
    day: 'numeric',
    month: 'short',
    ...(date.getFullYear() === now.getFullYear() ? {} : { year: 'numeric' }),
    hour: '2-digit',
    minute: '2-digit',
  }).format(date)
}

export function countLabel(value: number, locale: string): string {
  return new Intl.NumberFormat(locale).format(value)
}

export function percentLabel(ratio: number, locale: string): string {
  return new Intl.NumberFormat(locale, { style: 'percent', maximumFractionDigits: 0 }).format(ratio)
}
